import api from '~/api';
import { MvnFcListResponse } from '~/service/Model';


/** 공유시설 목록 조회 요청 파라미터 (inputType)
 * - hsmpCodeType: HSMP | CAMP(=CAMPA+CAMPB) | CAMPA | CAMPB
 * - HSMP: rntfeeAt(무료/유료) + targetUser(입주기업전용) 필터 적용
 * - CAMP계열: 시설명 검색만 적용
 */
export type MvnFcShareListParam = {
  mvnFcDtype?: string;
  mvnFcNm?: string;
  hsmpCodeType?: 'HSMP' | 'CAMP' | 'CAMPA' | 'CAMPB';
  rntfeeAt?: boolean;
  targetUser?: 'ALL' | 'MVNB';
  page: number;
  itemsPerPage: number;
};

/** @deprecated MvnFcShareListParam 사용 */
export type inputType = MvnFcShareListParam;

// 공유시설 유효목록 조회 (PRG-USP-IJS-09)
export default (data: MvnFcShareListParam): Promise<MvnFcListResponse> => {
  const params = new URLSearchParams();
  if (data.mvnFcDtype != null && data.mvnFcDtype !== '') params.set('mvnFcDtype', data.mvnFcDtype);
  if (data.hsmpCodeType) params.set('hsmpCodeType', data.hsmpCodeType);
  if (data.mvnFcNm) params.set('mvnFcNm', data.mvnFcNm);
  if (data.rntfeeAt !== undefined) params.set('rntfeeAt', String(data.rntfeeAt));
  if (data.targetUser) params.set('targetUser', data.targetUser);
  params.set('page', String(data.page));
  params.set('itemsPerPage', String(data.itemsPerPage));

  return api({
    url: `${process.env.REACT_APP_DOMAIN_MVN_BNET}/mvn/api/share-facilities?${params.toString()}`,
    method: 'get',
  });
};


export const fetchMvnFcDetail = (mvnFcId : string) =>
  api({
    url: `${process.env.REACT_APP_DOMAIN_MVN_BNET}/mvn/api/facilities/${mvnFcId}`,
    method:'get',
  })
